/**
 * Dashboard Address - Gerenciamento de endereços na página Minha Conta
 */

export function initDashboardAddress() {
  const $ = window.jQuery;
  const toast = window.Toast; // Usa o toast global

  // Configuração AJAX - fallback se dashboardParams não existir
  const ajaxUrl = window.dashboardParams?.ajax_url || window.ajaxurl || '/wp-admin/admin-ajax.php';
  const nonce = window.dashboardParams?.nonce || '';

  // Verifica se há mensagem pendente para exibir (após refresh)
  const pendingToast = sessionStorage.getItem('dashboard_toast');
  if (pendingToast && toast) {
    const { type, title, description } = JSON.parse(pendingToast);
    sessionStorage.removeItem('dashboard_toast');
    // Pequeno delay para garantir que a página carregou
    setTimeout(() => {
      if (type === 'success') {
        toast.success(title, description || '');
      } else if (type === 'error') {
        toast.error(title, description || '');
      }
    }, 300);
  }

  // ========================================
  // Formulário de Editar Informações Pessoais
  // ========================================
  initAccountInfoForm($, toast, ajaxUrl, nonce);

  // ========================================
  // Formulário de Alteração de Senha
  // ========================================
  initChangePasswordForm($, toast, ajaxUrl, nonce);

  // ========================================
  // Formulário de Alteração de E-mail
  // ========================================
  initChangeEmailForm($, toast, ajaxUrl, nonce);

  // ========================================
  // Formulário de Exclusão de Conta
  // ========================================
  initDeleteAccountForm($, toast, ajaxUrl, nonce);

  // ========================================
  // Formulário de Endereços
  // ========================================
  if (!$('#form-address').length) return;

  // Máscara de CEP
  const $cepInput = $('#form-address input[name="cep"]');
  const $cepSearchBtn = $('#form-address button[aria-label="Buscar CEP"]');
  const $cepErrorMessage = $('#cep-error-message');
  let isSearching = false;

  if ($cepInput.length) {
    $cepInput.on('input', function() {
      let value = $(this).val().replace(/\D/g, '');
      if (value.length > 8) {
        value = value.slice(0, 8);
      }
      if (value.length > 5) {
        value = value.replace(/^(\d{5})(\d{0,3})/, '$1-$2');
      }
      $(this).val(value);

      // Esconde a mensagem de erro ao digitar
      $cepErrorMessage.addClass('hidden');

      // Busca automaticamente quando completar 8 dígitos
      if (value.length === 8 && !isSearching) {
        searchCep();
      }
    });
  }

  // Busca de CEP ao clicar no botão
  $cepSearchBtn.on('click', function(e) {
    e.preventDefault();
    searchCep();
  });

  // Busca de CEP ao sair do campo (blur)
  $cepInput.on('blur', function() {
    const cep = $(this).val().replace(/\D/g, '');
    if (cep.length === 8 && !isSearching) {
      searchCep();
    }
  });

  function searchCep() {
    const cep = $cepInput.val().replace(/\D/g, '');

    if (cep.length !== 8) {
      $cepErrorMessage.removeClass('hidden');
      return;
    }

    if (isSearching) return;
    isSearching = true;

    // Salva o conteúdo original do botão
    const $btnIcon = $cepSearchBtn.find('div');
    const originalIcon = $btnIcon.html();

    // Mostra loading
    $cepInput.prop('disabled', true);
    $cepSearchBtn.prop('disabled', true);
    $btnIcon.html('<svg class="animate-spin" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>');

    $.ajax({
      url: `https://viacep.com.br/ws/${cep}/json/`,
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        if (data.erro) {
          // Mostra mensagem de erro no modal
          $cepErrorMessage.removeClass('hidden');
          return;
        }

        // Esconde mensagem de erro
        $cepErrorMessage.addClass('hidden');

        // Preenche os campos com os dados retornados
        $('#form-address input[name="address"]').val(data.logradouro);
        $('#form-address input[name="district"]').val(data.bairro);
        $('#form-address input[name="city"]').val(data.localidade);
        $('#form-address select[name="state"]').val(data.uf);

        // Foca no campo número
        setTimeout(function() {
          $('#form-address input[name="number"]').focus();
        }, 100);
      },
      error: function() {
        $cepErrorMessage.removeClass('hidden');
      },
      complete: function() {
        $cepInput.prop('disabled', false);
        $cepSearchBtn.prop('disabled', false);
        $btnIcon.html(originalIcon);
        isSearching = false;
      }
    });
  }

  // Resetar formulário para modo de criação quando abrir modal via botão de adicionar
  $(document).on('click', '[data-modal-target="#modal-address"]:not(.btn-edit-address)', function() {
    resetFormToCreateMode();
  });

  // Função para resetar o formulário para modo de criação
  function resetFormToCreateMode() {
    const $form = $('#form-address');

    // Limpa todos os campos
    $form[0].reset();

    // Define modo como criação
    $form.find('input[name="edit_mode"]').val('create');
    $form.find('input[name="address_type"]').val('');
    $form.find('input[name="address_index"]').val('');

    // Esconde mensagem de erro de CEP
    $cepErrorMessage.addClass('hidden');

    // Atualiza título do modal
    $('#modal-address-title').text('Adicionar endereço');

    // Pré-preenche nome e telefone do usuário (se disponível)
    if (typeof dashboardParams !== 'undefined') {
      if (dashboardParams.user_name) {
        $form.find('input[name="recipient_name"]').val(dashboardParams.user_name);
      }
      if (dashboardParams.user_phone) {
        $form.find('input[name="recipient_phone"]').val(dashboardParams.user_phone);
      }
    }
  }

  // Editar endereço - Abre modal com dados preenchidos
  $(document).on('click', '.btn-edit-address', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $btn = $(this);
    const $form = $('#form-address');

    // Pega os dados do botão
    const addressType = $btn.data('address-type');
    const addressIndex = $btn.data('address-index');
    const recipientName = $btn.data('recipient-name') || '';
    const recipientPhone = $btn.data('recipient-phone') || '';
    const cep = $btn.data('cep') || '';
    const address = $btn.data('address') || '';
    const number = $btn.data('number') || '';
    const complement = $btn.data('complement') || '';
    const district = $btn.data('district') || '';
    const city = $btn.data('city') || '';
    const state = $btn.data('state') || '';
    const instructions = $btn.data('instructions') || '';

    // Define modo de edição
    $form.find('input[name="edit_mode"]').val('edit');
    $form.find('input[name="address_type"]').val(addressType);
    $form.find('input[name="address_index"]').val(addressIndex !== undefined ? addressIndex : '');

    // Preenche os campos
    $form.find('input[name="recipient_name"]').val(recipientName);
    $form.find('input[name="recipient_phone"]').val(recipientPhone);
    $form.find('input[name="cep"]').val(formatCep(cep));
    $form.find('input[name="address"]').val(address);
    $form.find('input[name="number"]').val(number);
    $form.find('input[name="complement"]').val(complement);
    $form.find('input[name="district"]').val(district);
    $form.find('input[name="city"]').val(city);
    $form.find('select[name="state"]').val(state);
    $form.find('input[name="instructions"]').val(instructions);

    // Atualiza título do modal
    $('#modal-address-title').text('Editar endereço');

    // Esconde mensagem de erro de CEP
    $cepErrorMessage.addClass('hidden');

    // Abre o modal
    openModal($('#modal-address'));

    // Fecha o dropdown
    $btn.closest('.dropdown-menu').hide();
    $btn.closest('.relative').find('.dropdown-toggle').removeClass('active');
  });

  // Função para formatar CEP
  function formatCep(cep) {
    if (!cep) return '';
    const cleanCep = String(cep).replace(/\D/g, '');
    if (cleanCep.length === 8) {
      return cleanCep.replace(/^(\d{5})(\d{3})/, '$1-$2');
    }
    return cleanCep;
  }

  // Função para abrir modal
  function openModal($modal) {
    const backdrop = document.getElementById('backdrop');

    document.body.style.overflow = 'hidden';
    $modal.css('display', 'flex');
    $modal.addClass('active');

    if (backdrop) {
      backdrop.style.display = 'block';
      backdrop.style.opacity = '1';
      backdrop.style.pointerEvents = 'auto';
    }
  }

  // Submit do formulário
  $('#form-address').on('submit', function(e) {
    e.preventDefault();

    const $form = $(this);
    const $submitBtn = $('button[type="submit"][form="form-address"]');

    // Verifica se é edição ou criação
    const editMode = $form.find('input[name="edit_mode"]').val();
    const addressType = $form.find('input[name="address_type"]').val();
    const addressIndex = $form.find('input[name="address_index"]').val();

    // Define a action baseada no modo
    const action = editMode === 'edit' ? 'dashboard_update_address' : 'dashboard_save_address';

    // Coleta dados do formulário
    const formData = {
      action: action,
      nonce: nonce,
      recipient_name: $form.find('input[name="recipient_name"]').val(),
      recipient_phone: $form.find('input[name="recipient_phone"]').val(),
      cep: $form.find('input[name="cep"]').val(),
      address: $form.find('input[name="address"]').val(),
      number: $form.find('input[name="number"]').val(),
      complement: $form.find('input[name="complement"]').val(),
      neighborhood: $form.find('input[name="district"]').val(),
      city: $form.find('input[name="city"]').val(),
      state: $form.find('select[name="state"]').val(),
      instructions: $form.find('input[name="instructions"]').val()
    };

    // Adiciona dados de edição se for modo de edição
    if (editMode === 'edit') {
      formData.address_type = addressType;
      formData.address_index = addressIndex;
    }

    // Validações
    if (!formData.recipient_name || !formData.recipient_phone || !formData.cep || !formData.address || !formData.number || !formData.neighborhood || !formData.city || !formData.state) {
      toast.error('Erro', 'Preencha todos os campos obrigatórios.');
      return;
    }

    // Loading state
    const originalText = $submitBtn.find('span').text();
    $submitBtn.prop('disabled', true);
    $submitBtn.find('span').text('Salvando...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: formData,
      success: function(response) {
        if (response.success) {
          const title = 'Sucesso!';
          const description = editMode === 'edit' ? 'Endereço atualizado com sucesso.' : 'Endereço salvo com sucesso.';

          // Armazena a mensagem para exibir após o refresh
          sessionStorage.setItem('dashboard_toast', JSON.stringify({ type: 'success', title, description }));

          // Recarrega a página imediatamente
          window.location.reload();
        } else {
          toast.error(response.data?.message || 'Erro ao salvar endereço');
        }
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.data?.message || 'Erro ao salvar endereço. Tente novamente.';
        toast.error(message);
      },
      complete: function() {
        $submitBtn.prop('disabled', false);
        $submitBtn.find('span').text(originalText);
      }
    });
  });

  // Variável para armazenar o índice do endereço pendente
  let pendingAddressIndex = null;

  // Tornar endereço padrão - Abre modal de confirmação
  $(document).on('click', '.btn-set-default', function(e) {
    e.preventDefault();

    const $btn = $(this);
    const addressIndex = $btn.data('address-index');

    if (addressIndex === undefined) return;

    // Armazena o índice e abre o modal
    pendingAddressIndex = addressIndex;
    openConfirmModal($('#modal-confirm-default-address'));

    // Fecha o dropdown
    $btn.closest('.dropdown-menu').hide();
    $btn.closest('.relative').find('.dropdown-toggle').removeClass('active');
  });

  // Confirmar tornar endereço padrão
  $(document).on('click', '#btn-confirm-default-address', function(e) {
    e.preventDefault();

    if (pendingAddressIndex === null) return;

    const $btn = $(this);
    const originalText = $btn.find('span').text();
    $btn.prop('disabled', true);
    $btn.find('span').text('Salvando...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_set_default_address',
        nonce: nonce,
        address_index: pendingAddressIndex
      },
      success: function(response) {
        if (response.success) {
          // Armazena a mensagem para exibir após o refresh
          sessionStorage.setItem('dashboard_toast', JSON.stringify({ type: 'success', title: 'Sucesso!', description: 'Endereço definido como padrão.' }));

          // Recarrega a página imediatamente
          window.location.reload();
        } else {
          toast.error(response.data?.message || 'Erro ao definir endereço padrão');
        }
      },
      error: function() {
        toast.error('Erro ao processar solicitação. Tente novamente.');
      },
      complete: function() {
        $btn.prop('disabled', false);
        $btn.find('span').text(originalText);
        pendingAddressIndex = null;
      }
    });
  });

  // Remover endereço - Abre modal de confirmação
  $(document).on('click', '.btn-remove-address', function(e) {
    e.preventDefault();

    const $btn = $(this);
    const addressIndex = $btn.data('address-index');

    if (addressIndex === undefined) return;

    // Armazena o índice e abre o modal
    pendingAddressIndex = addressIndex;
    openConfirmModal($('#modal-confirm-remove-address'));

    // Fecha o dropdown
    $btn.closest('.dropdown-menu').hide();
    $btn.closest('.relative').find('.dropdown-toggle').removeClass('active');
  });

  // Confirmar remover endereço
  $(document).on('click', '#btn-confirm-remove-address', function(e) {
    e.preventDefault();

    if (pendingAddressIndex === null) return;

    const $btn = $(this);
    const originalText = $btn.find('span').text();
    $btn.prop('disabled', true);
    $btn.find('span').text('Removendo...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_remove_address',
        nonce: nonce,
        address_index: pendingAddressIndex
      },
      success: function(response) {
        if (response.success) {
          // Armazena a mensagem para exibir após o refresh
          sessionStorage.setItem('dashboard_toast', JSON.stringify({ type: 'success', title: 'Sucesso!', description: 'Endereço removido com sucesso.' }));

          // Recarrega a página imediatamente
          window.location.reload();
        } else {
          toast.error(response.data?.message || 'Erro ao remover endereço');
        }
      },
      error: function() {
        toast.error('Erro ao processar solicitação. Tente novamente.');
      },
      complete: function() {
        $btn.prop('disabled', false);
        $btn.find('span').text(originalText);
        pendingAddressIndex = null;
      }
    });
  });

  // Cancelar ações - limpa o índice pendente
  $(document).on('click', '#btn-cancel-default-address, #btn-cancel-remove-address', function() {
    pendingAddressIndex = null;
  });

  // Função para abrir modal de confirmação
  function openConfirmModal($modal) {
    const backdrop = document.getElementById('backdrop');

    document.body.style.overflow = 'hidden';
    $modal.css('display', 'flex');
    $modal.addClass('active');

    if (backdrop) {
      backdrop.style.display = 'block';
      backdrop.style.opacity = '1';
      backdrop.style.pointerEvents = 'auto';
    }
  }
}

/**
 * Inicializa o formulário de edição de informações pessoais
 */
function initAccountInfoForm($, toast, ajaxUrl, nonce) {
  const $form = $('#form-edit-account-info');

  if (!$form.length) return;

  // Máscara de data de nascimento
  $form.on('input', '.birthdate-mask', function() {
    let v = $(this).val().replace(/\D/g, '').slice(0, 8);
    v = v.replace(/^(\d{2})(\d)/, '$1/$2').replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
    $(this).val(v);
  });

  $form.on('submit', function(e) {
    e.preventDefault();

    const $submitBtn = $('button[type="submit"][form="form-edit-account-info"]');

    // Coleta dados do formulário
    const firstName = $form.find('input[name="first_name"]').val().trim();
    const lastName = $form.find('input[name="last_name"]').val().trim();
    const phone = $form.find('input[name="phone"]').val().trim();
    const $birthdateInput = $form.find('input[name="birthdate"]');
    const birthdate = $birthdateInput.val().trim();
    const birthdateReadonly = $birthdateInput.prop('readonly');

    // Validações
    if (!firstName) {
      toast.error('Erro', 'O nome é obrigatório.');
      return;
    }

    if (!phone) {
      toast.error('Erro', 'O telefone é obrigatório.');
      return;
    }

    // Valida data de nascimento apenas se não for readonly e tiver sido preenchida
    if (!birthdateReadonly && birthdate) {
      const clean = birthdate.replace(/\D/g, '');
      if (clean.length !== 8) {
        toast.error('Erro', 'Informe uma data de nascimento válida (DD/MM/AAAA).');
        return;
      }
    }

    // Loading state
    const originalText = $submitBtn.find('span').text();
    $submitBtn.prop('disabled', true);
    $submitBtn.find('span').text('Salvando...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_update_account_info',
        nonce: nonce,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        birthdate: birthdateReadonly ? '' : birthdate
      },
      success: function(response) {
        if (response.success) {
          // Armazena a mensagem para exibir após o refresh
          sessionStorage.setItem('dashboard_toast', JSON.stringify({
            type: 'success',
            title: 'Sucesso!',
            description: 'Informações atualizadas com sucesso.'
          }));

          // Recarrega a página imediatamente
          window.location.reload();
        } else {
          toast.error('Erro', response.data?.message || 'Erro ao atualizar informações.');
        }
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.data?.message || 'Erro ao atualizar informações. Tente novamente.';
        toast.error('Erro', message);
      },
      complete: function() {
        $submitBtn.prop('disabled', false);
        $submitBtn.find('span').text(originalText);
      }
    });
  });
}

/**
 * Inicializa o formulário de alteração de senha
 */
function initChangePasswordForm($, toast, ajaxUrl, nonce) {
  const $form = $('#form-change-password');

  if (!$form.length) return;

  const $errorCurrentPassword = $('#error-current-password');
  const $errorPasswordsMismatch = $('#error-passwords-mismatch');

  // Esconde erros ao digitar
  $form.find('input[name="current_password"]').on('input', function() {
    $errorCurrentPassword.addClass('hidden');
  });

  $form.find('input[name="new_password"], input[name="confirm_password"]').on('input', function() {
    $errorPasswordsMismatch.addClass('hidden');
  });

  $form.on('submit', function(e) {
    e.preventDefault();

    // Esconde todas as mensagens de erro
    $errorCurrentPassword.addClass('hidden');
    $errorPasswordsMismatch.addClass('hidden');

    const $submitBtn = $('button[type="submit"][form="form-change-password"]');

    // Coleta dados do formulário
    const currentPassword = $form.find('input[name="current_password"]').val();
    const newPassword = $form.find('input[name="new_password"]').val();
    const confirmPassword = $form.find('input[name="confirm_password"]').val();

    // Validações client-side
    if (!currentPassword) {
      toast.error('Erro', 'A senha atual é obrigatória.');
      return;
    }

    if (!newPassword) {
      toast.error('Erro', 'A nova senha é obrigatória.');
      return;
    }

    if (!confirmPassword) {
      toast.error('Erro', 'A confirmação de senha é obrigatória.');
      return;
    }

    if (newPassword !== confirmPassword) {
      $errorPasswordsMismatch.removeClass('hidden');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('Erro', 'A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    // Loading state
    const originalText = $submitBtn.find('span').text();
    $submitBtn.prop('disabled', true);
    $submitBtn.find('span').text('Alterando...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_change_password',
        nonce: nonce,
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword
      },
      success: function(response) {
        if (response.success) {
          // Armazena a mensagem para exibir após o refresh
          sessionStorage.setItem('dashboard_toast', JSON.stringify({
            type: 'success',
            title: 'Sucesso!',
            description: 'Senha alterada com sucesso.'
          }));

          // Recarrega a página imediatamente
          window.location.reload();
        } else {
          // Verifica o código de erro para exibir mensagem específica
          const errorCode = response.data?.code || '';

          if (errorCode === 'wrong_password') {
            $errorCurrentPassword.removeClass('hidden');
          } else if (errorCode === 'passwords_mismatch') {
            $errorPasswordsMismatch.removeClass('hidden');
          } else {
            toast.error('Erro', response.data?.message || 'Erro ao alterar senha.');
          }
        }
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.data?.message || 'Erro ao alterar senha. Tente novamente.';
        toast.error('Erro', message);
      },
      complete: function() {
        $submitBtn.prop('disabled', false);
        $submitBtn.find('span').text(originalText);
      }
    });
  });
}

/**
 * Inicializa o formulário de alteração de e-mail
 */
function initChangeEmailForm($, toast, ajaxUrl, nonce) {
  const $form = $('#form-change-email');

  if (!$form.length) return;

  const $errorEmailExists = $('#error-email-exists');
  const $errorEmailSame = $('#error-email-same');

  // Esconde erros ao digitar
  $form.find('input[name="new_email"]').on('input', function() {
    $errorEmailExists.addClass('hidden');
    $errorEmailSame.addClass('hidden');
  });

  $form.on('submit', function(e) {
    e.preventDefault();

    // Esconde todas as mensagens de erro
    $errorEmailExists.addClass('hidden');
    $errorEmailSame.addClass('hidden');

    const $submitBtn = $('button[type="submit"][form="form-change-email"]');

    // Coleta dados do formulário
    const newEmail = $form.find('input[name="new_email"]').val().trim();

    // Validação client-side
    if (!newEmail) {
      toast.error('Erro', 'O novo e-mail é obrigatório.');
      return;
    }

    // Validação básica de e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      toast.error('Erro', 'Por favor, insira um e-mail válido.');
      return;
    }

    // Loading state
    const originalText = $submitBtn.find('span').text();
    $submitBtn.prop('disabled', true);
    $submitBtn.find('span').text('Enviando...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_request_email_change',
        nonce: nonce,
        new_email: newEmail
      },
      success: function(response) {
        if (response.success) {
          // Fecha o modal
          $('[data-modal-close]').first().trigger('click');

          // Mostra toast de sucesso
          toast.success('Link enviado!', 'Verifique a caixa de entrada do e-mail ' + response.data.email + ' para confirmar a alteração.');

          // Limpa o formulário
          $form[0].reset();
        } else {
          // Verifica o código de erro para exibir mensagem específica
          const errorCode = response.data?.code || '';

          if (errorCode === 'email_exists') {
            $errorEmailExists.removeClass('hidden');
          } else if (errorCode === 'same_email') {
            $errorEmailSame.removeClass('hidden');
          } else {
            toast.error('Erro', response.data?.message || 'Erro ao solicitar alteração de e-mail.');
          }
        }
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.data?.message || 'Erro ao solicitar alteração de e-mail. Tente novamente.';
        toast.error('Erro', message);
      },
      complete: function() {
        $submitBtn.prop('disabled', false);
        $submitBtn.find('span').text(originalText);
      }
    });
  });
}

/**
 * Inicializa o formulário de exclusão de conta
 */
function initDeleteAccountForm($, toast, ajaxUrl, nonce) {
  const $form = $('#form-delete-account');

  if (!$form.length) return;

  const $errorPassword = $('#error-delete-password');
  const $modalPassword = $('#modal-delete-password');
  const $modalSuccess = $('#modal-delete-success');
  const $countdown = $('#delete-countdown');

  // Esconde erro ao digitar
  $form.find('input[name="password"]').on('input', function() {
    $errorPassword.addClass('hidden');
  });

  // Limpa o formulário quando o modal de senha abre
  $(document).on('click', '[data-modal-target="#modal-delete-password"]', function() {
    $form[0].reset();
    $errorPassword.addClass('hidden');
  });

  $form.on('submit', function(e) {
    e.preventDefault();

    // Esconde mensagem de erro
    $errorPassword.addClass('hidden');

    const $submitBtn = $('button[type="submit"][form="form-delete-account"]');

    // Coleta dados do formulário
    const password = $form.find('input[name="password"]').val();

    // Validação client-side
    if (!password) {
      toast.error('Erro', 'A senha é obrigatória.');
      return;
    }

    // Loading state
    const originalText = $submitBtn.find('span').text();
    $submitBtn.prop('disabled', true);
    $submitBtn.find('span').text('Excluindo...');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'dashboard_delete_account',
        nonce: nonce,
        password: password
      },
      success: function(response) {
        if (response.success) {
          // Fecha o modal de senha
          $modalPassword.removeClass('active').css('display', 'none');

          // Abre o modal de sucesso
          $modalSuccess.css('display', 'flex').addClass('active');

          // Mostra o backdrop
          const backdrop = document.getElementById('backdrop');
          if (backdrop) {
            backdrop.style.display = 'block';
            backdrop.style.opacity = '1';
            backdrop.style.pointerEvents = 'auto';
          }

          // Inicia contagem regressiva
          let seconds = 5;
          $countdown.text(seconds);

          const countdownInterval = setInterval(function() {
            seconds--;
            $countdown.text(seconds);

            if (seconds <= 0) {
              clearInterval(countdownInterval);
              // Redireciona para a home
              window.location.href = '/';
            }
          }, 1000);
        } else {
          // Verifica o código de erro
          const errorCode = response.data?.code || '';

          if (errorCode === 'wrong_password') {
            $errorPassword.removeClass('hidden');
          } else if (errorCode === 'is_admin') {
            toast.error('Erro', 'Administradores não podem excluir a própria conta.');
          } else {
            toast.error('Erro', response.data?.message || 'Erro ao excluir conta.');
          }
        }
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.data?.message || 'Erro ao excluir conta. Tente novamente.';
        toast.error('Erro', message);
      },
      complete: function() {
        $submitBtn.prop('disabled', false);
        $submitBtn.find('span').text(originalText);
      }
    });
  });
}
